/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  locale: 'ca',
  Pagination: {
    items_per_page: '/ pàgina',
    jump_to: 'Anar a',
    jump_to_confirm: 'Confirma',
    page: '',
    prev_page: 'Pàgina prèvia',
    next_page: 'Pàgina següent',
    prev_5: '5 pàgines prèvies',
    next_5: '5 pàgines següents',
    prev_3: '3 pàgines prèvies',
    next_3: '3 pàgines següents'
  },
  DatePicker: {
    lang: {
      placeholder: 'Seleccionar data',
      rangePlaceholder: ['Data inicial', 'Data final'],
      locale: 'ca_ES',
      today: 'Avui',
      now: 'Ara',
      backToToday: 'Tornar a avui',
      ok: 'Acceptar',
      clear: 'Netejar',
      month: 'Mes',
      year: 'Any',
      timeSelect: 'Seleccionar hora',
      dateSelect: 'Seleccionar data',
      monthSelect: 'Escollir un mes',
      yearSelect: 'Escollir un any',
      decadeSelect: 'Escollir una dècada',
      yearFormat: 'YYYY',
      dateFormat: 'D/M/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D/M/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Mes anterior (PageUp)',
      nextMonth: 'Mes següent (PageDown)',
      previousYear: 'Any anterior (Control + left)',
      nextYear: 'Mes següent (Control + right)',
      previousDecade: 'Dècada anterior',
      nextDecade: 'Dècada següent',
      previousCentury: 'Segle anterior',
      nextCentury: 'Segle següent'
    },
    timePickerLocale: {
      placeholder: 'Seleccionar hora'
    }
  },
  TimePicker: {
    placeholder: 'Seleccionar hora'
  },
  Calendar: {
    lang: {
      placeholder: 'Seleccionar data',
      rangePlaceholder: ['Data inicial', 'Data final'],
      locale: 'ca_ES',
      today: 'Avui',
      now: 'Ara',
      backToToday: 'Tornar a avui',
      ok: 'Acceptar',
      clear: 'Netejar',
      month: 'Mes',
      year: 'Any',
      timeSelect: 'Seleccionar hora',
      dateSelect: 'Seleccionar data',
      monthSelect: 'Escollir un mes',
      yearSelect: 'Escollir un any',
      decadeSelect: 'Escollir una dècada',
      yearFormat: 'YYYY',
      dateFormat: 'D/M/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D/M/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Mes anterior (PageUp)',
      nextMonth: 'Mes següent (PageDown)',
      previousYear: 'Any anterior (Control + left)',
      nextYear: 'Mes següent (Control + right)',
      previousDecade: 'Dècada anterior',
      nextDecade: 'Dècada següent',
      previousCentury: 'Segle anterior',
      nextCentury: 'Segle següent'
    },
    timePickerLocale: {
      placeholder: 'Seleccionar hora'
    }
  },
  global: {
    placeholder: 'Seleccionar'
  },
  Table: {
    filterTitle: 'Filtrar el menú',
    filterConfirm: 'D’acord',
    filterReset: 'Reiniciar',
    filterEmptyText: 'Sense filtres',
    selectAll: 'Seleccionar la pàgina actual',
    selectInvert: 'Invertir la selecció',
    selectionAll: 'Seleccionar-ho tot',
    sortTitle: 'Ordenar',
    expand: 'Ampliar la fila',
    collapse: 'Plegar la fila',
    triggerDesc: 'Ordre descendent',
    triggerAsc: 'Ordre ascendent',
    cancelSort: 'Desactivar l’ordre'
  },
  Modal: {
    okText: 'D’acord',
    cancelText: 'Cancel·lar',
    justOkText: 'D’acord'
  },
  Popconfirm: {
    okText: 'D’acord',
    cancelText: 'Cancel·lar'
  },
  Transfer: {
    titles: ['', ''],
    searchPlaceholder: 'Cercar',
    itemUnit: 'ítem',
    itemsUnit: 'ítems',
    remove: 'Eliminar',
    selectCurrent: 'Seleccionar la pàgina actual',
    removeCurrent: 'Eliminar la selecció',
    selectAll: 'Seleccionar-ho tot',
    removeAll: 'Eliminar-ho tot',
    selectInvert: 'Invertir la selecció'
  },
  Upload: {
    uploading: 'Carregant…',
    removeFile: 'Eliminar el fitxer',
    uploadError: 'Error de càrrega',
    previewFile: 'Vista prèvia del fitxer',
    downloadFile: 'Baixar el fitxer'
  },
  Empty: {
    description: 'Sense dades'
  },
  Icon: {
    icon: 'icona'
  },
  Text: {
    edit: 'Editar',
    copy: 'Copiar',
    copied: 'Copiat',
    expand: 'Ampliar'
  },
  PageHeader: {
    back: 'Enrere'
  }
};
